import { combineReducers } from 'redux';
import musicsPage from './MusicsPageReducer';
import musicSingle from './MusicSingleReducer';

// if there are more than one reducer in this component, use combineReducers

const musicsReducers = combineReducers({
    musicsPage,
    musicSingle,
});


export default musicsReducers;
